<template>
    <div class="book-keeping-container">
        <cloud-layout
            type="BK"
            name="代理记账服务"
        >
            <product-buy
                slot="buy"
                :base-info="baseInfo"
                type="bookkeeping"
                @buy="onBuy"
                @ask="onAsk"
            >
                <div
                    slot="form"
                    class="form-data-container"
                >
                    <div class="form-item">
                        <div class="form-label">服务地区：</div>
                        <div class="form-content">
                            <el-select
                                v-model="selectedRegionCode"
                                :filterable="true"
                                size="small"
                                @change="onRegionChange"
                            >
                                <el-option-group
                                    v-for="group in regionDatasource"
                                    :key="group.label"
                                    :label="group.label"
                                >
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-option-group>
                            </el-select>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">纳税人类型：</div>
                        <div class="form-content">
                            <div
                                v-for="item in taxpayerTypeDataSource"
                                :key="item.value"
                                :class="['select-item', item.value === selectedTaxpayerType ? 'be-selected' : '']"
                                @click="onSelect('taxpayerType', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === selectedTaxpayerType"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">年开票额：</div>
                        <div class="form-content">
                            <div
                                v-for="item in invoiceAmountDataSource"
                                :key="item.value"
                                :class="['select-item', item.value === selectedInvoiceAmount ? 'be-selected' : '']"
                                @click="onSelect('invoiceAmount', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === selectedInvoiceAmount"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">服务时长：</div>
                        <div class="form-content">
                            <div
                                v-for="item in serviceTimeDataSource"
                                :key="item.value"
                                :class="['select-item', item.value === selectedServiceTime ? 'be-selected' : '']"
                                @click="onSelect('serviceTime', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === selectedServiceTime"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </product-buy>
            <product-intro slot="intro">
                <div
                    slot="content"
                    class="product-info-content book-keeping-content"
                >
                    <div class="info-item-content book-title-content">
                        <h2 class="book-intro-title">服务介绍</h2>
                        <p
                            class="book-intro-des"
                        >{{ bookInfoDesc }}</p>
                        <div class="book-intro">
                            <div
                                v-for="(item, index) in intro"
                                :key="index"
                                class="book-intro-item"
                            >
                                <img :src="item.icon"/>
                                <p>{{ item.text }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="info-item-content book-title-content">
                        <h2 class="content-title">服务内容</h2>
                        <div class="book-content">
                            <div class="book-content-left">
                                <div
                                    v-for="(item, index) in serviceContent"
                                    :key="index"
                                    class="book-content-item"
                                >
                                    <div class="bk-icon"></div>
                                    <div class="bk-text">{{ item }}</div>
                                </div>
                            </div>
                            <div class="book-content-img"></div>
                        </div>
                    </div>
                    <div class="info-item-content advantage-content">
                        <h2 class="advantage-title">服务优势</h2>
                        <div class="book-advantage">
                            <div
                                v-for="(item, index) in advantage"
                                :key="index"
                                class="book-advantage-item"
                            >
                                <img :src="item.icon"/>
                                <div class="book-advantage-text">
                                    <h4>{{ item.title }}</h4>
                                    <p>{{ item.des }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-item-content process-content">
                        <h2 class="process-title">办理流程</h2>
                        <img
                            class="process-icon"
                            src="../assets/book_liucheng.png"
                        />
                    </div>
                    <div class="info-item-content materials-content">
                        <h2 class="materials-title">办理材料</h2>
                        <div class="book-materials">
                            <div
                                v-for="(item, index) in materials"
                                :key="index"
                                class="book-advantage-item"
                            >
                                <img :src="item.icon"/>
                                <h4>{{ item.title }}</h4>
                                <div class="materials-text">
                                    <p
                                        v-for="(desItem, index) in item.des"
                                        :key="index"
                                    >{{ desItem }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-item-content problem-content">
                        <h2 class="problem-title">常见问题</h2>
                        <img
                            class="problem-icon"
                            src="../assets/problem_icon.png"
                        />
                        <div class="problem-item-content">
                            <div
                                v-for="(item, index) in problem"
                                :key="index"
                                class="problem-item"
                            >
                                <h4>{{ item.title }}</h4>
                                <p>{{ item.des }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </product-intro>
        </cloud-layout>

        <!-- 获取用户手机号的弹窗 -->
        <el-dialog
            title="手机号码验证"
            :visible.sync="phoneDialogVisible"
            width="500px"
            top="240px"
        >
            <div class="form-container">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="80px"
                >
                    <el-form-item label="手机号码">
                        <el-input
                            v-model="form.newPhoneNumber"
                            size="medium"
                            placeholder="请输入手机号"
                            :maxlength="11"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="验证码">
                        <div class="form-content">
                            <el-input
                                v-model="form.name"
                                size="medium"
                                placeholder="请输入验证码"
                                :maxlength="6"
                            ></el-input>

                            <div
                                :class="['get-code-btn', getCodeBtnDisabled ? 'get-code-btn-disabled' : '']"
                            >{{ getCodeText }}</div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <div class="tip-row">您提供的手机号码仅会用于专家与您取得联系，请放心填写</div>

            <div class="protocol-row">
                <el-checkbox v-model="protocolChecked"></el-checkbox>
                <span>我已阅读并同意</span>
                <a
                    class="protocol-link"
                    href="https://www.baidu.com"
                    target="_blank"
                >《百度智能云代理记账服务协议》</a>
            </div>

            <div class="btns-container">
                <el-button
                    size="medium"
                    class="cancel-btn"
                >取消</el-button>
                <el-button
                    type="primary"
                    size="medium"
                    :disabled="!confirmBtnDisabled"
                >确认</el-button>
            </div>
        </el-dialog>

        <submit-dialog
            v-if="showSubmitDialog"
            @close="onClose"
        ></submit-dialog>
    </div>
</template>

<script>
import CloudLayout from '../components/CloudLayout.vue';
import ProductBuy from '../components/NewProductBuy.vue';
import ProductIntro from '../components/ProductIntro.vue';
import bookZhuanye from '../assets/book_zhuanye.png';
import bookDijia from '../assets/book_dijia.png';
import bookAnquan from '../assets/book_anquan.png';
import bookShouhou from '../assets/book_shouhou.png';
import bookOcr from '../assets/book_ocr.png';
import bookShishi from '../assets/book_shishi.png';
import bookZhineng from '../assets/book_zhineng.png';
import bookShuiwu from '../assets/book_shuiwu.png';
import bookShouci from '../assets/book_shouci.png';
import bookRichang from '../assets/book_richang.png';
import bookQiehu from '../assets/book_qiehu.png';
import keepIcon from '../assets/book_icon2.png';
import dacu from '../assets/dacu.png';

import DATA from '../common/data.js';
import client from '../common/client';
import {isLogin, isOnline} from '../util/helper';
import {store} from '../util/store';
import SubmitDialog from '../components/NewSubmitDialog.vue';

export default {
    components: {
        CloudLayout,
        ProductBuy,
        ProductIntro,
        SubmitDialog
    },
    metaInfo: {
        title: '代理记账服务_代理做账报税服务_百度智能云企业服务中心',
        meta: [
            {
                name: 'keywords',
                content: '代理记账,代账公司,记账报税,财税代理,全国代理记账'
            },
            {
                name: 'description',
                content: '百度智能云企业服务代理记账服务，资深团队多对一服务，做账准确，线上随时查账，服务范围支持全国'
            }
        ]
    },
    data() {
        return {
            showSubmitDialog: false,
            // eslint-disable-next-line
            bookInfoDesc: '企业支付不到一个人的成本，就可以享受到全国专业的服务；服务标准、定价公开透明、信息安全保密、服务进度透明、实时在线可查；覆盖全国主要区域，满足不同类型的企业需求，帮您轻松完成企业财务税务管理',
            phoneDialogVisible: false,
            protocolChecked: true,
            baseInfo: {
                icon: keepIcon,
                title: '代理记账服务',
                des: '云会计代理记账，品质服务，安心代账',
                price: '0元',
                unit: '/年',
                priceIcon: dacu,
                originPrice: '0元/年',
                advantage: ['实时响应，专家服务', '一次性收费，无隐形费用', '服务流程全监管'],
                serviceAdvantage: ['经营性网站必备资质', '助企业合法合规经营', '新品上架，限时优惠']
            },
            typeDatasource: [
                {
                    text: '零申报',
                    value: 'zero'
                },
                {
                    text: '小规模',
                    value: 'small'
                },
                {
                    text: '一般纳税人',
                    value: 'normal'
                }
            ],
            typeSelected: 'zero',
            smallMoneyDatasource: [
                {
                    text: '0-120万元',
                    value: 'small'
                },
                {
                    text: '120-300万元',
                    value: 'normal'
                },
                {
                    text: '300-700万元',
                    value: 'large'
                }
            ],
            moneySelected: 'small',
            normalMoneyDatasource: [
                {
                    text: '0-300万元',
                    value: 'small'
                },
                {
                    text: '300-700万元',
                    value: 'normal'
                },
                {
                    text: '700-2000万元',
                    value: 'large'
                }
            ],
            yearDatasource: [
                {
                    text: '1年',
                    value: 1
                }
            ],
            yearSelected: 1,
            selectItem: DATA.productData[0],
            intro: [
                {
                    text: '专业咨询',
                    icon: bookZhuanye
                },
                {
                    text: '低价透明',
                    icon: bookDijia
                },
                {
                    text: '安全保密',
                    icon: bookAnquan
                },
                {
                    text: '售后无忧',
                    icon: bookShouhou
                }
            ],
            advantage: [
                {
                    icon: bookOcr,
                    title: 'OCR票据识别',
                    des: '运用OCR图像扫描技术，帮助会计快速识别票据并查验核实真伪，提高做账效率'
                },
                {
                    icon: bookShishi,
                    title: '实时查账',
                    des: '在线查看企业账务情况，服务进度实时可查，一目了然'
                },
                {
                    icon: bookZhineng,
                    title: '智能生成凭证',
                    des: '将发票或单据自动匹配会计科目，根据不同经济活动将票据分类，自动生成对应凭证'
                },
                {
                    icon: bookShuiwu,
                    title: '税务风险预警',
                    des: '对帐数据发现风险第一时间预警，并提供相关财税建议'
                }
            ],
            materials: [
                {
                    title: '首次做账所需材料',
                    des: ['营业执照', '税号及报税密码'],
                    icon: bookShouci
                },
                {
                    title: '日常月度记账所需材料',
                    des: ['发票清单', '银行对账单、回执单、工资单'],
                    icon: bookRichang
                },
                {
                    title: '切户所需材料',
                    des: ['交接单/历史账簿/凭证/纳税申报表', '税号及报税密码，税控盘（可选）'],
                    icon: bookQiehu
                }
            ],
            problem: [
                {
                    title: '什么是0申报？',
                    des: '0申报需要符合 1、无银行、支付宝、微信流水（账户管理费除外） 2、无票据（收入票、费用票）3、除法人外无社保、员工工资 4、无纳税额 '
                },
                {
                    title: '我获得的服务结果？',
                    des: '财务报表、记账凭证、纳税申报表、账本'
                },
                {
                    title: '都有什么票据可以用来做账？',
                    des: '发票、银行单据、工资表、现金借款收支单据等'
                },
                {
                    title: '我可以不请会计，自己做账吗？',
                    des: '不行的，《会计法》规定从事会计工作的人员都必须取得会计从业资格证，必须是会计才能做账'
                },
                {
                    title: '新注册的公司没业务，是否可以不记账不报税？',
                    des:
                        '不可以，工商、税务已经于2015年6月1日与中国人民银行个人引用征信系统联网，公司未注销的情况下，必须做账报税，否则法人及股东将会有信用污点'
                },
                {
                    title: '每月几号开始记账，几号报税？',
                    des: '每月票收到就开始记账，1-15日报税，法定节假日按照税局要求调整'
                }
            ],
            serviceContent: [
                '建立账套',
                '整理原始凭证',
                '每月核对票据',
                '每月编制记账凭证',
                '编制资产负债表、利润表',
                '增值税、印花税、附加税、个人所得税、企业所得税等纳税申报',
                '每月装订记账凭证，总账、明细账、财税报表',
                '企业所得税年度汇算清缴申报',
                '工商年报（企业年检）'
            ],
            // 纳税人类型
            taxpayerTypeDataSource: [
                {
                    label: '小规模纳税人',
                    value: 'SMALL_SCALE_TAXPAYER'
                },
                {
                    label: '一般纳税人',
                    value: 'GENERAL_TAXPAYER'
                }
            ],
            selectedTaxpayerType: 'SMALL_SCALE_TAXPAYER',
            // 年开票额
            invoiceAmountDataSource: [
                {
                    label: '零申报',
                    value: 'ZERO'
                },
                {
                    label: '非零申报',
                    value: 'SMALL'
                }
            ],
            selectedInvoiceAmount: 'ZERO',
            serviceTimeDataSource: [
                {
                    label: '1年',
                    value: 1
                }
            ],
            selectedServiceTime: 1,
            bkpCities: [],
            nameToCode: {},
            regionDatasource: [],
            selectedRegionCode: 110100,
            priceCache: {},
            originPriceMap: {
                // 小规模纳税人-零申报
                'SMALL_SCALE_TAXPAYER-ZERO': 1999,
                // 小规模纳税人-非零申报
                'SMALL_SCALE_TAXPAYER-SMALL': 2799,
                // 一般纳税人-零申报
                'GENERAL_TAXPAYER-ZERO': 1999,
                // 一般纳税人-非零申报
                'GENERAL_TAXPAYER-SMALL': 5999
            },
            form: {
                originPhoneNumber: '',
                newPhoneNumber: '',
                verifyCode: ''
            },
            hasLogin: false,
            count: 60
        };
    },
    computed: {
        moneyDatasource() {
            if (this.typeSelected === 'normal') {
                return this.normalMoneyDatasource;
            }
            return this.smallMoneyDatasource;
        },

        getCodeBtnDisabled() {
            return !/^1\d{10}$/.test(this.form.newPhoneNumber) || this.count < 60;
        },

        getCodeText() {
            if (this.count < 60) {
                return `倒计时${this.count}秒`;
            }

            return '获取验证码';
        },

        confirmBtnDisabled() {
            return !(
                this.protocolChecked &&
                /^1\d{10}$/.test(this.form.newPhoneNumber) &&
                /^\d{6}$/.test(this.form.verifyCode)
            );
        }
    },
    async created() {
        this.queryPrice();
        // // 获取省市区静态数据
        let staticDataResponse = await this.getStaticData();
        if (staticDataResponse && staticDataResponse.status === 200 && staticDataResponse.data) {
            const {bkpCities, nameToCode} = staticDataResponse.data;
            this.bkpCities = bkpCities;
            this.nameToCode = nameToCode;

            this.convertRegionDataToGroupData();
        }
    },
    mounted() {
        isLogin().then(res => {
            this.hasLogin = res && res.result && res.result.hasLogin;
        });
    },
    methods: {
        onClose() {
            this.showSubmitDialog = false;
        },

        // 获取省市区静态数据
        getStaticData() {
            return new Promise(resolve => {
                client.queryStaticData().then(res => {
                    resolve(res);
                });
            });
        },

        // 将省市区转化为分组数据
        convertRegionDataToGroupData() {
            let result = [];
            this.bkpCities.forEach(item => {
                let groupLabel = item.groupName;
                let options = [];
                item.groupItems.forEach(groupItem => {
                    groupItem.rowItems.forEach(rowItem => {
                        options.push({
                            label: rowItem,
                            value: parseInt(this.nameToCode[rowItem], 10)
                        });
                    });
                });
                result.push({
                    label: groupLabel,
                    options
                });
            });
            this.regionDatasource = result;
            store.setRegionDatasource(result);
            if (window.location.href.indexOf('from=require') > -1) {
                this.showSubmitDialog = true;
               const href = window.location.href.replace('from=require', '');
                window.history.pushState({}, '', href);
            }
        },

        onSelect(type, item) {
            switch (type) {
                case 'taxpayerType': {
                    if (this.selectedTaxpayerType === item) {
                        return;
                    }
                    this.selectedTaxpayerType = item;
                    break;
                }
                case 'invoiceAmount': {
                    if (this.selectedInvoiceAmount === item) {
                        return;
                    }
                    this.selectedInvoiceAmount = item;
                    break;
                }
                case 'serviceTime': {
                    if (this.selectedServiceTime === item) {
                        return;
                    }
                    this.selectedServiceTime = item;
                    break;
                }
                default: {
                    break;
                }
            }
            this.queryPrice();
        },
        onBuy() {
            let targetOrigin = isOnline ? 'https://console.bce.baidu.com' : 'https://qasandbox.bcetest.baidu.com';
            // eslint-disable-next-line
            let targetUrl = `${targetOrigin}/cbs/#/bkp/order/submit?stepStart=2&region=${this.selectedRegionCode}&taxpayerType=${this.selectedTaxpayerType}&serviceTime=${this.selectedServiceTime}&invoiceAmount=${this.selectedInvoiceAmount}`;
            window.open(targetUrl, '_blank');
        },
        onAsk() {
            this.showSubmitDialog = true;
        },

        // 查询价格
        queryPrice() {
            this.setOriginPrice();

            client
                .queryBkpPrice({
                    area: this.selectedRegionCode,
                    taxpayerType: this.getTaxpayerTypeTextFromValue(this.selectedTaxpayerType),
                    invoiceAmount: this.selectedInvoiceAmount
                })
                .then(res => {
                    if (res.status === 200 && res.data) {
                        this.baseInfo.price = res.data.price + '元';
                    }
                });
        },

        getTaxpayerTypeTextFromValue(val) {
            let index = this.taxpayerTypeDataSource.findIndex(item => item.value === val);
            return index > -1 ? this.taxpayerTypeDataSource[index].label : '';
        },

        // 设置商品原价
        setOriginPrice() {
            let key = `${this.selectedTaxpayerType}-${this.selectedInvoiceAmount}`;
            this.baseInfo.originPrice = this.originPriceMap[key] + '元/年';
        },

        // 监听地区发生变化
        onRegionChange() {
            this.queryPrice();
        }
    }
};
</script>

<style lang="less">
.book-intro-title {
    background-image: url(../assets/book_title_bac.png);
}
.book-intro-des {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #191c3d;
    opacity: 0.6;
    margin: 10px auto 48px;
    text-align: center;
    width: 816px;
}
.book-intro {
    width: 608px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto 39px;
    .book-intro-item {
        width: 96px;
    }
    img {
        width: 96px;
        height: 96px;
        display: block;
    }
    p {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #191c3d;
        opacity: 0.8;
        height: 22px;
        text-align: center;
        margin-top: 16px;
    }
}
.process-content {
    .process-icon {
        display: block;
        width: 833px;
        height: 227px;
        margin: 20px auto 40px;
    }
}
.book-advantage {
    width: 814px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px auto 14px;
    .book-advantage-item {
        width: 391px;
        height: 109px;
        background: #ffffff;
        box-shadow: 0px 0px 10px rgba(13, 78, 255, 0.16);
        padding: 16px;
        margin-bottom: 30px;
        img {
            width: 40px;
            height: 40px;
            float: left;
        }
        .book-advantage-text {
            margin-left: 50px;
            h4 {
                height: 25px;
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 25px;
                color: #191c3d;
            }
            p {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                opacity: 0.65;
            }
        }
    }
}
.book-materials {
    width: 815px;
    margin: 26px auto 50px;
    display: flex;
    justify-content: space-between;
    .book-advantage-item {
        position: relative;
        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 260px;
            height: 58px;
        }
        h4 {
            width: 260px;
            height: 58px;
            padding-top: 17px;
            padding-left: 10px;
            position: relative;
            z-index: 10;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 25px;
            color: #ffffff;
        }
        .materials-text {
            height: 69px;
            border: 1px solid #d8d8d8;
            border-top: none;
            padding-top: 8px;
            padding-left: 23px;
            p {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                opacity: 0.8;
                position: relative;
            }
            p:before {
                content: '';
                position: absolute;
                left: -10px;
                top: 6px;
                width: 6px;
                height: 6px;
                background: #fd6c41;
                display: block;
                border-radius: 50%;
            }
        }
    }
}

.book-keeping-container {
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #2468f2;
    }

    .el-select .el-input__inner:focus {
        border-color: #2468f2;
    }

    .el-dialog {
        border-radius: 10px;

        .el-dialog__header {
            border-bottom: 1px solid #f2f2f2;
            padding-bottom: 20px;

            .el-dialog__title {
                font-size: 16px;
                color: #000;
                font-weight: bold;
            }
        }

        .el-dialog__body {
            .el-form-item__label {
                color: #000;
            }
        }

        .tip-row {
            font-size: 14px;
            color: #666;
            text-align: center;
        }

        .protocol-row {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 6px;

            span {
                margin-left: 10px;
            }

            .protocol-link {
                color: #2468f2;
            }
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #2468f2;
            border-color: #2468f2;
        }

        .el-form-item {
            margin-bottom: 15px;
        }

        .form-content {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .el-input__inner {
                width: 270px;
            }

            .get-code-btn {
                white-space: nowrap;
                border: 1px solid #dcdfe6;
                box-sizing: border-box;
                height: 36px;
                line-height: 36px;
                border-radius: 4px;
                font-size: 12px;
                width: 140px;
                text-align: center;
                user-select: none;
                cursor: pointer;
            }
        }

        .el-input__inner:active {
            border-color: #2468f2;
        }

        .btns-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            .el-button {
                width: 120px;

                &:first-child {
                    margin-right: 20px;
                }
            }

            .cancel-btn {
                &:hover {
                    color: #666;
                    background-color: transparent;
                    border-color: #dcdfe6;
                }
            }

            .el-button--primary {
                background-color: #2468f2;
                border-color: #2468f2;
            }
        }
    }
}

.book-content {
    display: flex;
    justify-content: space-between;
    padding: 27px 50px 33px;
    .book-content-item {
        display: flex;
        margin-bottom: 16px;
        align-items: flex-start;
    }
    .bk-text {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #1b1e3f;
        letter-spacing: 0;
        font-weight: 400;
        width: 320px;
    }
    .bk-icon {
        background: url('../assets/book_service_icon.png') no-repeat;
        width: 22px;
        height: 22px;
        background-size: cover;
        margin-right: 12px;
    }
    .book-content-img {
        width: 410px;
        height: 348px;
        background: url('../assets/book_service_content.png') no-repeat;
        background-size: cover;
    }
}
</style>
